import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import lodashSortBy from 'lodash/fp/sortBy';

import branch from 'client/core/branch';
import { SCREEN_ID_LOCATOR_TOURS_LANDING_PAGE } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import ApartmentActions from 'client/actions/Apartment';

import SrText from 'client/components/SrText';
import SrCardLink from 'client/components/SrCardLink';
import SrBox from 'client/components/SrBox';
import SrLocatorToursNavbar from 'client/components/SrLocatorToursNavbar';
import SrContactUsButton from 'client/components/SrContactUsButton';

@withTransitionHook
@withScreenId(SCREEN_ID_LOCATOR_TOURS_LANDING_PAGE)
@withScrollToTop
@branch({
  apartments: ['apartments', 'list'],
})
class LocatorToursLandingPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Locator Tours',
  });

  static fetchData(match, inject) {
    return ApartmentActions.getList(inject, {
      filters: {
        withLockboxCode: true,
      },
    });
  }

  static propTypes = {
    apartments: PropTypes.array,
  };

  render() {
    const { apartments } = this.props;
    if (!apartments) {
      return null;
    }

    const apartmentsWithActiveListings = lodashSortBy(
      'name',
      apartments.filter(({ fieldsForDisplay }) => fieldsForDisplay.floorPlansCount > 0),
    );

    return (
      <SrBox marginBottom="200px" className="margin-left-right-20">
        <SrLocatorToursNavbar
          withLogo
          withTopPadding
          redirectTo="/locatortours"
          cornerNode={<SrContactUsButton />}
        />
        <SrBox width="240px" paddingBottom="25px">
          <SrText size="40" weight="bolder" leading="45" font="greycliff">
            Choose apartment to tour
          </SrText>
        </SrBox>
        {apartmentsWithActiveListings.map((apartment) => {
          const cardLinkLabel = [
            apartment.fieldsForDisplay.addressStreetNumber,
            apartment.fieldsForDisplay.addressStreetName,
            apartment.fieldsForDisplay.addressStreetSuffix,
            apartment.fieldsForDisplay.address,
          ].join(' ');

          return (
            <SrCardLink
              key={apartment.id}
              to={`/locatortours/${apartment.id}`}
              thumbnailUrl={(apartment.photoUrls || [])[0]}
              title={apartment.name}
              label={cardLinkLabel}
              sublabel={`${pluralize(
                'unit',
                apartment.fieldsForDisplay.activeListings,
                true,
              )} ready for touring`}
            />
          );
        })}
      </SrBox>
    );
  }
}

LocatorToursLandingPage.displayName = 'LocatorToursLandingPage';

export default LocatorToursLandingPage;
